import type { Component } from 'svelte';
import { buildWikiIndex, type WikiIndex } from './wiki-index';

// Jedyny plik silnika wiki dotykający Vite. Wzorzec globa (gwiazdka na segment
// językowy) pomija pliki w korzeniu `wiki/` (README, d.ts) — content żyje
// wyłącznie w katalogach językowych.
const metadataModules = import.meta.glob('/src/content/wiki/*/**/*.{md,svx}', {
	eager: true,
	import: 'metadata'
});
const pageModules = import.meta.glob('/src/content/wiki/*/**/*.{md,svx}');

let cached: WikiIndex | undefined;

export function getWikiIndex(): WikiIndex {
	cached ??= buildWikiIndex(
		Object.entries(metadataModules).map(([path, metadata]) => ({ path, metadata }))
	);
	return cached;
}

export async function loadWikiComponent(filePath: string): Promise<Component> {
	const loader = pageModules[filePath];
	if (loader === undefined) {
		throw new Error(`Wiki content module not found: ${filePath}`);
	}
	const mod = (await loader()) as { default: Component };
	return mod.default;
}
